import { message } from 'antd';
import { useState } from 'react';
import { Notification } from '@/components';
import { ModelInputStyle } from './style';
import { SENDTOKEN_PRICE } from '@/config';
import { useSelector } from 'react-redux';
import { chainId } from '@/store';
import { chains } from '@/utils/wagmi';
import { Input } from '../Input';

interface PropType {
  callBack: () => void;
  handleOks: (val: string | { value: string; extraValue: string }) => void;
  title: string;
  type: number;
  account?: string;
  msg?: string[];
  confirm?: string;
}

const App = (props: PropType) => {
  const { callBack, title, handleOks, type, msg, confirm, account } = props;
  const [value, setValue] = useState('');
  const [extraValue, setExtraValue] = useState('');
  const _chainId = useSelector(chainId);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: number,
    field: 'value' | 'extra'
  ) => {
    const val = e.target.value;

    if (type === 1 && field === 'value') {
      if (!/^\d*\.?\d*$/.test(val)) {
        return message.error('请输入正确数字');
      }
    }

    field === 'value' ? setValue(val) : setExtraValue(val);
  };

  const handleOk = () => {
    if (type === 1 && !account) {
      if (!extraValue) return Notification.Error('未连接钱包，输入框不能为空');
    }

    if (type === 1) {
      if (!value) return Notification.Error('数量不能为空');
      handleOks({ value, extraValue });
    } else if (type === 2) {
      handleOks(extraValue);
    } else {
      handleOks(value);
    }

    callBack();
  };

  const handleCancel = () => {
    callBack();
  };

  const handleOverlayClick = () => handleCancel();
  const handleModalClick = (e: React.MouseEvent) => e.stopPropagation();

  const nativeSymbol = chains.find(c => c.id === _chainId)?.nativeCurrency?.symbol || '';

  return (
    <ModelInputStyle>
      <div className="custom-modal-overlay" onClick={handleOverlayClick}>
        <div className="custom-modal" onClick={handleModalClick}>
          <div className="custom-modal-header">
            <span className="modal-title">{title}</span>
            <button className="close-btn" onClick={handleCancel}>
              ×
            </button>
          </div>

          {msg && msg.length > 0 && (
            <div className="list">
              {msg.map((item, index) => (
                <div className="notice" key={index}>
                  {item}
                </div>
              ))}
            </div>
          )}

          {/* 数量输入框 */}
          {(type === 1 || type === 3) && (
            <div className="custom-modal-body">
              <label className="input-label">数量</label>
              <Input
                type="text"
                value={value}
                onChange={e => handleChange(e, 1, 'value')}
                placeholder="2"
                className="custom-modal-input"
              />
            </div>
          )}

          {/* 地址或私钥输入框 */}
          {(type === 2 || type === 1) && (
            <div className="custom-modal-body">
              <label className="input-label">{type === 2 ? '地址' : '私钥'}</label>
              <Input
                type="text"
                value={extraValue}
                onChange={e => handleChange(e, type, 'extra')}
                placeholder={type === 2 ? '0x...' : '不填默认连接钱包转账'}
                className="custom-modal-input"
              />
            </div>
          )}

          {type === 1 && (
            <div className="fee-info">
              <span className="fee-label">费用</span>
              <span className="fee-original">
                {SENDTOKEN_PRICE[_chainId]} {nativeSymbol}
              </span>
              <span className="fee-member">
                会员 {SENDTOKEN_PRICE[_chainId] / 2} {nativeSymbol}
              </span>
              <span className="fee-unit">/200地址</span>
            </div>
          )}

          <div className="custom-modal-footer">
            <button className="btn btn-cancel" onClick={handleCancel}>
              取消
            </button>
            <button className="btn btn-ok" onClick={handleOk}>
              {confirm || '确定'}
            </button>
          </div>
        </div>
      </div>
    </ModelInputStyle>
  );
};

export default App;